import {TemplatesWebFrontendRequest} from "services-comun-ed/modules/services/templates/frontend-web";
import {IComponentWindow} from "./interface";
import {UserHeaderController} from "./inicio";
import {Auth} from "../firebase/auth";
import {IUsuario} from "services-comun-ed/modules/services/usuarios/interface";

export class SugerenciaPopupController {

    /* INSTANCE */
    public static instance: SugerenciaPopupController;
    private sugerencia?: IComponentWindow;

    /* STATIC */
    public static async build(): Promise<SugerenciaPopupController> {
        return SugerenciaPopupController.instance = new this();
    }

    private constructor() {
    }

    public async getComponent(): Promise<IComponentWindow> {
        const data = await TemplatesWebFrontendRequest.loginPopUpSugerencia();
        const sugerencia = new DOMParser().parseFromString(data.data, 'text/html').body.firstChild as HTMLElement;
        this.sugerencia = {
            window: sugerencia,
            buttons: {
                close: sugerencia.querySelector(".circulo-sg") as HTMLElement,
                go_page: sugerencia.querySelector("#goToUserPage") as HTMLElement,
                dont_show: sugerencia.querySelector(".texto-nomostrar-sg") as HTMLElement,
                remind_later: sugerencia.querySelector(".texto-recordar-sg") as HTMLElement,
            }
        }
        await this.init();
        document.getElementsByTagName("body").item(0)?.appendChild(this.sugerencia!.window);
        return this.sugerencia as IComponentWindow;
    }

    private async init(): Promise<void> {
        this.sugerencia?.buttons?.close?.addEventListener("click", () => {
            this.sugerencia!.window.style.display = "none";
            UserHeaderController.instance.destroyOverlay();
        });
        this.sugerencia?.buttons?.remind_later?.addEventListener("click", () => {
            this.sugerencia!.window.style.display = "none";
            UserHeaderController.instance.destroyOverlay();
        });
        this.sugerencia?.buttons?.dont_show?.addEventListener("click", () => {
            const user = Auth.get()?.userEd as IUsuario;
            user.configuracion!.registro_inicial!.popup_sugerencia!.frecuencia!.registro = user.configuracion!.registro_inicial!.popup_sugerencia!.frecuencia!.value as number;
            Auth.get()?.update(user, false);
            this.sugerencia!.window.style.display = "none";
            UserHeaderController.instance.destroyOverlay();
        });
    }

}
